import React from 'react';
import { theme } from '../../theme';

function StatCard({ icon, label, value, color = theme.primary, subtext, trend }) {
  return (
    <div
      style={{
        background: theme.cardBg,
        borderRadius: '0.75rem',
        padding: '1.25rem 1.5rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.07)',
        border: `1px solid ${theme.border}`,
        display: 'flex',
        alignItems: 'flex-start',
        gap: '1rem',
        borderLeft: `4px solid ${color}`,
      }}
    >
      {icon && (
        <div
          style={{
            width: '48px',
            height: '48px',
            borderRadius: '0.75rem',
            background: `${color}18`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.4rem',
            flexShrink: 0,
          }}
        >
          {icon}
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <p
          style={{
            fontSize: '0.78rem',
            fontWeight: 500,
            color: theme.textMuted,
            marginBottom: '0.25rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          {label}
        </p>
        <p
          style={{
            fontSize: '1.75rem',
            fontWeight: 700,
            color: theme.text,
            lineHeight: 1.2,
            margin: 0,
          }}
        >
          {value}
        </p>
        {subtext && (
          <p style={{ fontSize: '0.78rem', color: theme.textMuted, marginTop: '0.25rem' }}>{subtext}</p>
        )}
        {trend && (
          <p
            style={{
              fontSize: '0.78rem',
              color: trend > 0 ? theme.success : theme.danger,
              marginTop: '0.25rem',
              fontWeight: 500,
            }}
          >
            {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}% from last month
          </p>
        )}
      </div>
    </div>
  );
}

export default StatCard;
